import { RxCustomerAPI } from '@driftt/dapper'

export const fetchGeolocation = () => {
  return RxCustomerAPI
    .get('/location')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => response)
}
